<!--
 by:wangyingyu
 2019.9.18
 -->
<template>
    <div class="box" v-if="show">
        <div class="mask" @click="close"></div>
        <div class="con">
            <div class="title">
                转发消息
                <a href="javascript:;" @click="close"></a>
            </div>
            <div class="selfri_box">
                <div class="selfri_l">
                    <el-input
                        clearable
                        placeholder="请输入内容"
                        size="small"
                        v-model="searchValue">
                        <i slot="prefix" class="el-input__icon iconfont">&#xe7ce;</i>
                        <!-- <i slot="suffix" class="el-input__icon iconfont">&#xe6a8;</i> -->
                    </el-input>
                    <el-scrollbar class="list_box" ref='searchbar'>
                        <ul v-if="list.records.length >0">
                            <li v-for="(item,index) in list.records" :key="index">
                                <img :src="item.avatar ? item.avatar:'/static/img/defaluttx.png'" alt="">
                                <p class="textEllipsis" :title="item.remark ? item.remark + ' - '+item.nickname :item.nickname">{{item.remark ? item.remark + ' - ' :''}}{{item.nickname}}</p>
                                <a href="javascript:;" :class="{ active: item.select}" @click="selfriends(item)"></a>
                            </li>
                        </ul>
                        <p v-else class="empty">无“{{searchValue}}”的相关信息</p>
                    </el-scrollbar>
                </div>
                <div class="selfri_l selfri_r">
                    <div class="topbox">
                        <div>
                            分别转发给：
                        </div>
                        <span>{{ seldata.length>0 ? '已选择'+seldata.length+'个好友' : '未选择好友'}}</span>
                    </div>
                    <el-scrollbar class="list_box">
                        <ul>
                            <li v-for="(item,index) in seldata" :key="index">
                                <img :src="item.avatar ? item.avatar:'/static/img/defaluttx.png'" alt="">
                                <p class="textEllipsis" :title="item.remark ? item.remark + ' - '+item.nickname :item.nickname">{{item.remark ? item.remark + ' - ' :''}}{{item.nickname}}</p>
                                <a href="javascript:;" :class="{ active: item.select}" @click="selfriends(item,true)"></a>
                            </li>
                        </ul>
                    </el-scrollbar>
                    <div class="selbtn_box">
                        <el-button size="small" @click.stop="close">取消</el-button>
                        <el-button size="small" type="primary" :disabled="seldata.length==0"  @click.stop="save">发送</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    chatFriendList,
    relayMessage
} from '@/utils/api-im.js'
export default {
    name: 'selfriend',
    data() {
        return {
            searchValue:'',
            sloading:true,
            spage:1,
            list:{
                records: []
            },
            timeout:null,
            seldata:[]
        }
    },
    props:{
        show:{
            type:Boolean,
            default:false
        },
        contentIdList:{
            type:Array,
            default:[]
        }
    },
    watch:{
        searchValue (curVal, oldVal) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.list = {
                    records: []
                }
                this.spage = 1
                this.sloading = true
                this.searchfriend(curVal);
            }, 300);
        }
    },
    mounted(){
        this.searchfriend('')
        
    },
    methods:{
        close(){
            this.$emit('closeselfriend')
        },
        save(){
            console.log(this.seldata)
            let voList = []
            let wxarr = []
            // 取出设备列表
            this.seldata.forEach(v=>{
                wxarr.push(v.wechatid)
            })
            // 去重
            wxarr = Array.from(new Set(wxarr))
            wxarr.forEach(k=>{
                voList.push({
                    weChatId:k,
                    friendIdList:[]
                })
            })
            // 重组数据 
            this.seldata.forEach(v=>{
                voList.forEach(k=>{
                    if(v.wechatid == k.weChatId){
                        k.friendIdList.push(v.friendid)
                    }
                })
            })
            console.log(voList)
            this.$post(relayMessage, {
                contentIdList: this.contentIdList,
                voList:voList
            }).then(res=>{
                if(res.data.code == 200){
                    this.$emit('closeselfriend')
                }
                this.$toast(res.data.msg)
            })
        },
        selfriends(obj,bool){
            const data = {...this.list}
            let arr = [...this.seldata]
            if(bool){
                arr = arr.filter(k=>{
                    return k.id!=obj.id
                })
            }
            data.records.forEach(v => {
                if(v.id === obj.id){
                    v.select = !v.select
                    if(v.select){
                        arr.push(v)
                    }else{
                        arr = arr.filter(k=>{
                            return k.id!=obj.id
                        })
                    }
                }
                
            });
            if(arr.length >10){
                this.$toast('最多只能选择10个好友')
                return false
            }else{
                this.list = data
                this.seldata = arr
            }
        },
        searchfriend(curVal){
            if(this.sloading){
                this.sloading = false
                this.$post(chatFriendList, {
                    remark: curVal,
                    current:this.spage,
                    onlyOnlineWeChatFriend:1
                }).then(res => {
                    if (res.data.code == 200) {
                        let sdate = res.data.data
                        const obj = {...this.list}
                        if(sdate.records.length>0){
                            obj.records = obj.records.concat(sdate.records)
                            if(sdate.records.length==10){
                                setTimeout(res=>{
                                    this.spage++
                                    this.sloading = true
                                },300)
                            }
                            obj.records.forEach(v=>{
                                this.seldata.forEach(val=>{
                                    if(v.id === val.id){
                                        v.select = true
                                    }
                                })
                            })
                            this.list = obj
                            console.log(this.list)
                        }
                        let div1 = this.$refs['searchbar'].$refs['wrap'];
                        let _this = this;

                        if (div1.scrollTop == div1.scrollHeight - div1.offsetHeight) {
                            setTimeout(() => {
                                _this.searchfriend(curVal)
                            }, 500);
                        }
                        div1.addEventListener('scroll', () => {
                            this.menuVisible = false
                            if (div1.scrollHeight - div1.offsetHeight - div1.scrollTop  <= 40) {
                                _this.searchfriend(curVal)
                            }
                        })
                    } else {
                        this.$toast(res.data.msg);
                    }
                })
            }
            
        },
    }
};
</script>

<style lang="less" scoped>
    .box{
        .mask{
            position: fixed;
            top:0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            z-index: 99998;
        }
        .con{
            position: fixed;
            top:50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width:642px;
            height:542px;
            background:rgba(255,255,255,1);
            border-radius:4px;
            z-index: 99999;
            overflow: hidden;

            .title{
                height: 50px;
                line-height: 50px;
                background: #F3F5F7;
                color: #2a2a2a;
                font-size: 14px;
                font-weight:500;
                padding-left: 16px;
                position: relative;
                a{
                    position: absolute;
                    top: 50%;
                    right: 23px;
                    transform: translateY(-50%);
                    display: block;
                    width: 12px;
                    height: 12px;
                    background: url(/static/img/close2.png) center no-repeat;
                    background-size: 12px 12px;
                }
            }

            .selfri_box{
                display: flex;
                .selfri_l{
                    width: 288px;
                    height: 478px;
                    padding: 12px 16px 0;
                    border-right: 1px solid #E2E2E2;

                    /deep/ input{
                        padding-left: 20px;
                    }

                    .list_box{
                        height: 430px;
                        margin-top: 18px;
                        width: 306px;

                        li{
                            height: 46px;
                            margin-bottom: 16px;
                            margin-right: 17px;
                            padding-right: 50px;
                            position: relative;
                            display: flex;
                            align-items: center;
                            overflow: hidden;

                            img{
                                width: 42px;
                                height: 42px;
                                border-radius: 50%;
                                margin-right: 8px;
                            }

                            p{
                                flex: 1;
                                height: 20px;
                                font-size: 14px;
                                line-height: 20px;
                                &.textEllipsis {
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                            }

                            a{
                                display: block;
                                position: absolute;
                                top: 50%;
                                left: 270px;
                                width: 16px;
                                height: 16px;
                                transform: translateY(-50%);
                                background: url(/static/img/icon_nosel.png) center no-repeat;
                                background-size: 16px 16px;
                                &.active{
                                    background: url(/static/img/icon_sel.png) center no-repeat;
                                    background-size: 16px 16px;
                                }
                            }
                        }
                    }
                }
                .selfri_r{
                    .topbox{
                        height: 32px;
                        display: flex;
                        justify-content: space-between;
                        div{
                            font-weight: 500;
                        }
                        span{
                            color: #999;
                            font-size: 12px;
                        }
                    }
                    .list_box{
                        height: 360px;
                        li{
                            a{
                                &.active{
                                    background: url(/static/img/ic_delete.png) center no-repeat;
                                    background-size: 16px 16px;
                                }
                            }
                        }
                    }
                    .selbtn_box{
                        float: right;
                        margin-top: 12px;
                        margin-right: 7px;
                    }
                }
            }
        }
        .empty{
            text-align: center;
            color: #b5b9bc;
            font-size: 12px;
            line-height: 18px;
            margin-top: 48px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/selfriend.vue